import moment from 'moment';

// 获取三大类型中返回的时间最早的一个
export const getMinMetricDate = (dateList: any) => {
  const tempList: any = [];
  for (const n in dateList) {
    if (dateList[n] && dateList[n] != '' && dateList[n] != '1970-01-01') {
      tempList.push(new Date(dateList[n]).getTime());
    }
  }
  return moment(Math.min(...tempList)).format('YYYY-MM-DD');
};

export function toLowerArr(val) {
  if (!val) {
    return [];
  }
  return val.map((item) => {
    return item?.toLocaleLowerCase();
  });
}
